import styled from "styled-components";
import { useAllContexts } from "../../../hooks/useAllContexts";

const HeatMapButton = () => {
  const { variables } = useAllContexts();
  const { showHeatMap, setShowHeatMap } = variables;

  return (
    <HeatMapBtn
      $isSelected={showHeatMap}
      onClick={() => setShowHeatMap(!showHeatMap)}
    >
      {showHeatMap ? "Απόκρυψη heat map parking" : "Εμφάνιση heat map parking"}
    </HeatMapBtn>
  );
};

export default HeatMapButton;

const HeatMapBtn = styled.div`
  position: absolute;
  bottom: 0;
  left: calc((100vw - 480px) / 2);
  width: 240px;
  height: 26px;
  background-color: ${({ $isSelected }) => ($isSelected ? "green" : "#ff0000")};
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  z-index: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px 20px 0 0;

  &:hover {
    background-color: #ffb09c;
    transition: all 0.3s ease-in-out;
    color: #333;
  }
`;
